'use client';

import { c as _c } from "react/compiler-runtime";
import { motion, useScroll, useTransform } from 'framer-motion';
import { careerData } from '@/data/career';
interface YearMarkerProps {
  year: string;
  index: number;
}
const YearMarker = t0 => {
  const $ = _c(21);
  const {
    year,
    index
  } = t0;
  const {
    scrollYProgress
  } = useScroll();
  const totalSections = 1 + careerData.length + 3 + 2 + 1;
  const careerStart = 1 / totalSections;
  const careerEnd = (1 + careerData.length) / totalSections;
  const step = (careerEnd - careerStart) / careerData.length;
  const start = careerStart + index * step;
  const end = start + step;
  const t1 = Math.max(0, start);
  const t2 = Math.min(1, end);
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = [t1, t2];
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = ["10%", "-10%"];
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const y = useTransform(scrollYProgress, t3, t4);
  const t5 = Math.max(0, start - 0.05);
  const t6 = Math.max(0, start);
  const t7 = Math.min(1, end);
  const t8 = Math.min(1, end + 0.05);
  let t9;
  if ($[4] !== t5 || $[5] !== t6 || $[6] !== t7 || $[7] !== t8) {
    t9 = [t5, t6, t7, t8];
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
    $[7] = t8;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = [0, 0.08, 0.08, 0];
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  const opacity = useTransform(scrollYProgress, t9, t10);
  let t11;
  if ($[10] !== opacity || $[11] !== y) {
    t11 = {
      y,
      opacity
    };
    $[10] = opacity;
    $[11] = y;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== year) {
    t12 = year.includes("Present") ? "2026" : year.split(" ")[0];
    $[13] = year;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== t12) {
    t13 = <span className="text-[15rem] md:text-[25rem] font-serif italic tracking-tighter leading-none select-none text-white whitespace-nowrap">{t12}</span>;
    $[15] = t12;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="h-[40vh] w-px bg-gradient-to-b from-white/20 to-transparent" />;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== t11 || $[19] !== t13) {
    t15 = <motion.div style={t11} className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">{t13}{t14}</motion.div>;
    $[18] = t11;
    $[19] = t13;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  return t15;
};
const BackgroundMarkers = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">{careerData.map(_temp)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default BackgroundMarkers;
function _temp(milestone, i) {
  return <YearMarker key={i} index={i} year={milestone.year} />;
}